import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "default" | "primary" | "ghost" | "danger" | "icon";
type Size = "default" | "sm";

type BtnProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  icon?: ReactNode;
};

export function Btn({
  variant = "default",
  size = "default",
  icon,
  children,
  className = "",
  ...rest
}: BtnProps) {
  const cls = [
    "btn",
    variant !== "default" ? variant : "",
    size !== "default" ? size : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button className={cls} {...rest}>
      {icon}
      {children}
    </button>
  );
}
